// extracted by mini-css-extract-plugin
module.exports = {"serverMsgContainer":"ServerMsg_serverMsgContainer__2m2H1","serverMsgBox":"ServerMsg_serverMsgBox__17Xh3","serverMsg":"ServerMsg_serverMsg__30s5B"};